var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 3.4375C1.25 2.91992 1.66992 2.5 2.1875 2.5H17.8125C18.332 2.5 18.75 2.91992 18.75 3.4375C18.75 3.95703 18.332 4.375 17.8125 4.375H2.1875C1.66992 4.375 1.25 3.95703 1.25 3.4375ZM1.25 9.6875C1.25 9.16797 1.66992 8.75 2.1875 8.75H17.8125C18.332 8.75 18.75 9.16797 18.75 9.6875C18.75 10.207 18.332 10.625 17.8125 10.625H2.1875C1.66992 10.625 1.25 10.207 1.25 9.6875ZM17.8125 16.875H2.1875C1.66992 16.875 1.25 16.457 1.25 15.9375C1.25 15.418 1.66992 15 2.1875 15H17.8125C18.332 15 18.75 15.418 18.75 15.9375C18.75 16.457 18.332 16.875 17.8125 16.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.d492956c6d8585d0f60ce6ab5e3ce364.svg";
export { ForwardRef as ReactComponent };